var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable array-callback-return */
import React, { useContext, useEffect } from 'react';
import io from 'socket.io-client';
import feathers from '@feathersjs/client';
import auth from '@feathersjs/authentication-client';
import { useSnackbar } from 'notistack';
import { api } from '../../environment.vars';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { catchUserDeActivated } from '../../helpers/catchUserDeActivated';
import { loggerError, logger } from '../../helpers/Log';
import { CentralProviderErrorTypes } from '../../constants/centralProviderErrors';
import { useGetAccessToken } from '../../hooks/useGetAccessToken';
var socket;
var client;
try {
    socket = io(api, {
        path: '/notifications/socket.io/',
    });
    client = feathers();
    client.configure(feathers.socketio(socket));
    client.configure(auth());
}
catch (error) {
    loggerError(error);
}
var channelSubscriptions = [];
export function NotificationClient() {
    var _this = this;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    var contextValue = useContext(CentralProviderContext);
    var accessToken = useGetAccessToken();
    useEffect(function () {
        logger('NotificationClient', contextValue && contextValue.centralProfile && contextValue.centralProfile.auth0 ? contextValue.centralProfile.auth0 : 'NO PROFILE');
        if (contextValue.centralProfile
            && contextValue.centralProfile.auth0
            && contextValue.centralProfile.auth0.sub
            && accessToken) {
            var subscribe = function () { return __awaiter(_this, void 0, void 0, function () {
                var params, key, service, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            params = {
                                query: {
                                    authorization: "Bearer ".concat(accessToken),
                                },
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            key = "user-".concat(contextValue.centralProfile.auth0.sub);
                            if (!!channelSubscriptions.includes(key)) return [3 /*break*/, 3];
                            channelSubscriptions.push(key);
                            logger('NotificationClient subscribe channel', contextValue.centralProfile.auth0.sub);
                            return [4 /*yield*/, client.service('notifications/channels')];
                        case 2:
                            service = _a.sent();
                            service
                                .create({
                                channelType: 'user',
                                channelId: contextValue.centralProfile.auth0.sub,
                            }, params)
                                .catch(function (e) { return console.log('Notification service exception', e); });
                            _a.label = 3;
                        case 3:
                            contextValue.centralProfile.channels.map(function (c) {
                                var type = c.split('-');
                                var typeKey = "".concat(type[0], "-").concat(type[1]);
                                if (!channelSubscriptions.includes(typeKey)) {
                                    channelSubscriptions.push(typeKey);
                                    logger('NotificationClient subscribe channel', type[0], type[1]);
                                    var service = client.service('notifications/channels');
                                    service
                                        .create({
                                        channelType: type[0],
                                        channelId: type[1],
                                    }, params)
                                        .catch(function (e) { return console.log('Notification service exception', e); });
                                }
                            });
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _a.sent();
                            loggerError(error_1);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }); };
            socket.on('notifications/notifications notificationCreated', function (data) {
                if (catchUserDeActivated(data.notification)) {
                    logger('user deactivated');
                    contextValue.setError({
                        key: CentralProviderErrorTypes.USER_DEACTIVATED,
                    });
                }
                // disable to avoid duplicate notifications on FO just for now
                // if (data.notification.messages) {
                //   data.notification.messages.map((message: any) => {
                //     enqueueSnackbar(message.text, {
                //       variant: 'info',
                //       anchorOrigin: {
                //         vertical: 'top',
                //         horizontal: 'right',
                //       },
                //     });
                //   });
                // }
            });
            subscribe();
        }
    }, []);
    return React.createElement("div", null);
}
export { useSnackbar };
//# sourceMappingURL=NotificationClient.js.map